import { onboardingApi } from ".";
import type { Guarantor, GuarantorPost } from "../types/guarantor";
import {
	assignGuarantor,
	fetchGuarantorAgreement,
	fetchGuarantors,
	removeGuarantor,
	setupGuarantorAgreement,
} from "./endpoints/guarantors";

const guarantorSlice = onboardingApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchGuarantors: builder.query<Guarantor[], string>({
			query: (applicationId) => fetchGuarantors(applicationId),
			transformResponse: (response: { data: Guarantor[] }) => response.data,
			providesTags: ["AssignedGuarantors"],
			extraOptions: { withAuth: true },
		}),
		assignGuarantor: builder.mutation<
			void,
			{
				applicationId: string;
				guarantor: GuarantorPost;
			}
		>({
			query: ({ applicationId, guarantor }) => assignGuarantor(applicationId, guarantor),
			invalidatesTags: ["CurrentApplication", "AssignedGuarantors"],
			extraOptions: {
				revision: true,
				allowRevisionConflict: true,
				withAuth: true,
			},
		}),
		removeGuarantor: builder.mutation<
			void,
			{
				applicationId: string;
				swedishNationalId: string;
			}
		>({
			query: ({ applicationId, swedishNationalId }) =>
				removeGuarantor(applicationId, swedishNationalId),
			extraOptions: {
				revision: true,
				allowRevisionConflict: true,
				withAuth: true,
			},
			invalidatesTags: ["CurrentApplication", "AssignedGuarantors"],
		}),
		setupGuarantorAgreement: builder.mutation<
			void,
			{
				applicationId: string;
			}
		>({
			query: ({ applicationId }) => setupGuarantorAgreement(applicationId),
			extraOptions: {
				revision: true,
				allowRevisionConflict: false,
				withAuth: true,
			},
		}),
		fetchGuarantorAgreement: builder.query<string, string>({
			query: (applicationId) => fetchGuarantorAgreement(applicationId),
			transformResponse: (response: { document: string }) => response.document,
			extraOptions: { withAuth: true },
		}),
	}),
});

export const {
	useFetchGuarantorsQuery,
	useAssignGuarantorMutation,
	useRemoveGuarantorMutation,
	useSetupGuarantorAgreementMutation,
	useLazyFetchGuarantorAgreementQuery,
} = guarantorSlice;
